"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
var formClass = document.querySelector(".form");
function submitForm(event) {
    event.preventDefault();
    formClass.reset();
}
formClass.addEventListener("submit", submitForm);

//# sourceMappingURL=index.08084537.js.map
